import { useEffect } from "react";
import { useForm } from "react-final-form";
import { OtlFormSubmission } from "./OtlFormSubmission";

export function OtlAutosave({
  save,
  onDirty,
}: {
  onDirty: () => void;
  save: (values: Partial<OtlFormSubmission>) => void;
}) {
  const form = useForm<OtlFormSubmission>();
  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;
    const unsubscribe = form.subscribe(
      ({ values }) => {
        clearTimeout(timer);
        onDirty();
        timer = setTimeout(() => save(values), 500);
      },
      { values: true },
    );
    const flush = () => {
      if (document.visibilityState === "hidden") save(form.getState().values);
    };
    document.addEventListener("visibilitychange", flush);
    return () => {
      clearTimeout(timer);
      unsubscribe();
      document.removeEventListener("visibilitychange", flush);
    };
  }, [form, save, onDirty]);
  return null;
}
